// Come si scrivono numeri, importi e date nel gestionale (pacchetto del 29-10, lib/format.ts).
// Intl con "it-IT" non mette il punto nei numeri a 4 cifre (4743), quindi il raggruppamento è fatto a mano.

const raggruppa = (intero) => intero.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

/** 31582 -> "31.582"; 4743.55 con decimali -> "4.743,55" */
export function numero(n, decimali = 0) {
  const segno = n < 0 ? "−" : "";
  const [i, d] = Math.abs(n).toFixed(decimali).split(".");
  return segno + raggruppa(i) + (d ? "," + d : "");
}

/** Totali della dashboard senza centesimi, preventivi e incassi con i centesimi. */
export function euro(n, opzioni = {}) {
  return numero(n, opzioni.centesimi ? 2 : 0) + " €";
}

/** Assi dei grafici: 40000 -> "40 mila", 96800 -> "96,8 mila". */
export function mila(n) {
  if (n === 0) return "0";
  const v = Math.round(n / 100) / 10;
  return String(v).replace(".", ",") + " mila";
}

/** 0.459 -> "45,9%" (senza spazio, con la virgola). */
export function percentuale(frazione, decimali = 1) {
  return (frazione * 100).toFixed(decimali).replace(".", ",") + "%";
}

const GIORNI = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];
const GIORNI_LUNGHI = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
const MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

const soloGiorno = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** "11:33" */
export function ora(d) {
  return d.getHours() + ":" + String(d.getMinutes()).padStart(2, "0");
}

/** Elenchi fitti e righe: "mer 28 ottobre" (con l'anno solo se non è quello di oggi). */
export function data(d, oggi = new Date()) {
  const anno = d.getFullYear() !== oggi.getFullYear() ? " " + d.getFullYear() : "";
  return `${GIORNI[d.getDay()]} ${d.getDate()} ${MESI[d.getMonth()]}${anno}`;
}

/** Frasi e scadenze: "lunedì 2 novembre" (con l'anno solo se non è quello di oggi). */
export function giorno(d, oggi = new Date()) {
  const anno = d.getFullYear() !== oggi.getFullYear() ? " " + d.getFullYear() : "";
  return `${GIORNI_LUNGHI[d.getDay()]} ${d.getDate()} ${MESI[d.getMonth()]}${anno}`;
}

/** Date a parole: "oggi", "ieri", "domani", altrimenti "lunedì 2 novembre". Con l'ora: "ieri alle 22:10". */
export function quando(d, opzioni = {}) {
  const oggi = opzioni.oggi ?? new Date();
  const diff = Math.round((soloGiorno(d) - soloGiorno(oggi)) / 86400000);
  let testo;
  if (diff === 0) testo = "oggi";
  else if (diff === -1) testo = "ieri";
  else if (diff === 1) testo = "domani";
  else testo = giorno(d, oggi);
  return opzioni.conOra ? `${testo} alle ${ora(d)}` : testo;
}

/** "1 scaduta" / "2 scadute": il singolare e il plurale si scelgono sempre. */
export function conteggio(n, singolare, plurale) {
  return `${numero(n)} ${n === 1 ? singolare : plurale}`;
}

/** "fino all'11 novembre", "firmato l'8": apostrofo davanti a 8, 11 e 1. */
export function articoloGiorno(g) {
  return g === 1 || g === 8 || g === 11 ? "l'" + g : "il " + g;
}
